import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import lazyload from "./features/lazy-load";
import VueTinySlider from "vue-tiny-slider";

lazyload();
initMain(
  [],
  {
    SectionPager: () =>
      import("./vue/components/section-pager/SectionPager.vue"),
    VueTinySlider,
    Trends: () => import("./vue/components/trends/Trends.vue"),
  },
  [],
);
header();
